export default __webpack_public_path__ + "static/media/large_white.b66dfbc6.svg";